'use client';
import axiosObj from "./axios";
import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { getUserInfo } from "@/utils/useUserInfo";
import { useAuth } from "@nestingale/auth/hooks";

const Campaign = ({ campaignName, pageName }: {  campaignName: string, pageName: string }) => {
    const searchParams = useSearchParams();
    const { userEmail } = useAuth();
    useEffect(() => {
        // App Router doesn't need isReady check - searchParams are always available
        const queryCampaign = searchParams.get('utm_campaign');
            //may be we should use setCampaignName state.. TBD
        campaignName = queryCampaign || campaignName;
        const medium = searchParams.get('utm_medium');
            if (campaignName && medium !== 'email') {
                const showCampaign = async () => {
                    try {
                        const response = await axiosObj.get('/api/email-marketing/campaigns?campaignName=' + campaignName);
                        const campaignData = response.data[0];
                        const loggedInEmail = userEmail;
                        if (campaignData &&
                                campaignData.active &&
                                campaignData.pageNames?.includes(pageName) &&
                                (!campaignData.suppressOnLogin || !loggedInEmail)
                            ) {
                            const userInfo = await getUserInfo();
                            const script = document.createElement('script');
                            script.async = true;
                            script.src = campaignData.script;
                            script.dataset.cid = userInfo?.cId;
                            script.dataset.form = campaignData.form;
                            document.body.appendChild(script);
                        }
                    } catch (error) {
                        console.error('Error fetching campaign:', error);
                    }
                };
                showCampaign();
            }
    }, [searchParams, campaignName, pageName, userEmail]);

    return null;
};

export default Campaign;
